<template>
    <div class="report-container">

        <main class="content-main">
            <section class="title-group">
                <h1 class="main-title-text">多维汲取</h1>
                <div class="sub-title-wrapper">
                    <span class="eco-badge">📊</span>
                    <h2 class="sub-title-text">构建你的认知生态</h2>
                </div>
            </section>

            <section class="total-score-section">
                <p class="summary-hint">上半年你共获得学分</p>
                <div class="massive-number-box">
                    <span class="massive-num">{{ ReportData.creditvalue }}</span>
                    <span class="unit-text">分</span>
                </div>
                <p class="poetic-sentence">它们像不同的养分，滋养着你的职业树木。</p>
            </section>

            <section class="eco-flow-container">

                <div class="eco-item slide-in-1" v-if="parseFloat(teacherPercent) !== 0">
                    <div class="eco-blur-bg"></div>
                    <div class="eco-left-bar bar-teacher"></div>
                    <div class="eco-content">
                        <div class="eco-header">
                            <span class="label">讲师学分</span>
                            <span class="ratio">占比 <span class="percent-num">{{ teacherPercent }}%</span></span>
                        </div>
                        <p class="desc">懂得输出，是最高级的输入。</p>
                    </div>
                </div>

                <div class="eco-item slide-in-2" v-if="parseFloat(onlinePercent) !== 0">
                    <div class="eco-blur-bg"></div>
                    <div class="eco-left-bar bar-online"></div>
                    <div class="eco-content">
                        <div class="eco-header">
                            <span class="label">线上学分</span>
                            <span class="ratio">占比 <span class="percent-num">{{ onlinePercent }}%</span></span>
                        </div>
                        <p class="desc">利用碎片时间，搭建完整的逻辑。</p>
                    </div>
                </div>

                <div class="eco-item slide-in-3" v-if="parseFloat(offlinePercent) !== 0">
                    <div class="eco-blur-bg"></div>
                    <div class="eco-left-bar bar-offline"></div>
                    <div class="eco-content">
                        <div class="eco-header">
                            <span class="label">线下学分</span>
                            <span class="ratio">占比 <span class="percent-num">{{ offlinePercent }}%</span></span>
                        </div>
                        <p class="desc">面对面的碰撞，激荡出创新的火花。</p>
                    </div>
                </div>

            </section>
        </main>

        <div class="tech-line"></div>
    </div>
</template>

<script>
export default {
    props: ["ReportData"],

    computed: {
        // 1. 核心解析逻辑：将字符串转化为 JSON 对象，并处理键名映射
        parsedCreditRate() {
            // 健壮性兜底：如果数据还没传过来，或者字段为空，返回默认 0
            if (!this.ReportData || !this.ReportData.creditvalueRate) {
                return { teacher: 0, online: 0, offline: 0 };
            }

            try {
                // 解析接口返回的转义字符串 "{\"线下\": 14.02, \"讲师\": 0.0, \"富学宝典\": 85.98}"
                const rawObj = JSON.parse(this.ReportData.creditvalueRate);

                return {
                    teacher: rawObj["讲师"] || 0,
                    online: rawObj["富学宝典"] || 0,  // "富学宝典" 对应 线上学分
                    offline: rawObj["线下"] || 0
                };
            } catch (error) {
                console.error("解析 creditvalueRate 数据失败:", error);
                return { teacher: 0, online: 0, offline: 0 };
            }
        },

        // 2. 映射到你 HTML 模板中绑定的三个变量
        teacherPercent() {
            return this.parsedCreditRate.teacher;
        },
        onlinePercent() {
            return this.parsedCreditRate.online;
        },
        offlinePercent() {
            return this.parsedCreditRate.offline;
        }
    }
}
</script>

<style scoped>
/* 容器及原汁原味背景设定 */
.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    padding: 35px 28px;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26June/bg.jpg") no-repeat;
    background-size: 100% 100%, cover;
    font-family: -apple-system, "SF Pro Text", "PingFang SC", sans-serif;
    display: flex;
    flex-direction: column;
}

/* 主体容器 */
.content-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 30px;
    z-index: 2;
}

/* 1. 现代感大标题排版 */
.title-group {
    animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.main-title-text {
    font-size: 34px;
    font-weight: 900;
    margin: 0;
    letter-spacing: 4px;
    color: #004d40;
    /* 沉稳高级墨绿色 */
}

.sub-title-wrapper {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.eco-badge {
    font-size: 9px;
    font-family: "DIN Alternate", sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    background: #004d40;
    color: #ffffff;
    padding: 1px 5px;
    border-radius: 4px;
    margin-right: 8px;
    letter-spacing: 0.5px;
}

.sub-title-text {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #1e293b;
    letter-spacing: 1px;
}

/* 2. 核心数字巨幕设计（视觉中心点） */
.total-score-section {
    text-align: center;
    margin: 20px 0;
    animation: fadeIn 1s ease-out both;
}

.summary-hint {
    font-size: 18px;
    color: #252a32;
    margin: 0 0 4px 0;
    letter-spacing: 1px;
}

.massive-number-box {
    display: inline-flex;
    align-items: baseline;
    justify-content: center;
}

/* 数字采用极其大气的墨绿渐变色 */
.massive-num {
    font-size: 48px;
    font-weight: 900;
    font-family: "DIN Alternate", "Helvetica Neue", sans-serif;
    line-height: 1;
    background: linear-gradient(180deg, #e65100 0%, #e65100 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.unit-text {
    font-size: 18px;
    font-weight: 700;
    color: #e65100;
    margin-left: 4px;
}

.poetic-sentence {
    font-size: 16px;
    color: #26282a;
    margin: 10px 0 0 0;
    font-weight: 400;
    letter-spacing: 0.5px;
}

/* 3. 维度生态流：完全没有硬框，利用极轻微的毛玻璃浮层和彩色呼吸边框 */
.eco-flow-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.eco-item {
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 16px;
    padding: 16px 20px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.4);
    /* 极细白边，营造透明水晶质感 */
    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.05);
}

/* 微弱的毛玻璃背景，能完美透出底部的亮蓝色背景图 */
.eco-blur-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    z-index: 1;
}

.eco-content {
    position: relative;
    z-index: 2;
    width: 100%;
}

/* 三种维度的左侧优雅彩色呼吸条 */
.eco-left-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    z-index: 2;
}

.bar-teacher {
    background: #00796b;
}

.bar-online {
    background: #e65100;
}

.bar-offline {
    background: #0288d1;
}

/* 卡片内部排版 */
.eco-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.eco-header .label {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
}

.eco-header .ratio {
    font-size: 13px;
    color: #475569;
    font-weight: 500;
}

.percent-num {
    font-size: 18px;
    font-weight: 700;
    font-family: "DIN Alternate", sans-serif;
}

/* 讲师、线上、线下各自匹配亮眼色系 */
.eco-item:nth-child(1) .percent-num {
    color: #00796b;
}

.eco-item:nth-child(2) .percent-num {
    color: #e65100;
}

.eco-item:nth-child(3) .percent-num {
    color: #0288d1;
}

.eco-content .desc {
    font-size: 15px;
    color: #334155;
    margin: 0;
    line-height: 1.4;
}

/* 右下角极其微弱的纤细斜线，增添精美科技感 */
.tech-line {
    position: absolute;
    right: -20px;
    bottom: 25%;
    width: 120px;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(0, 77, 64, 0.15), rgba(255, 255, 255, 0));
    transform: rotate(-30deg);
}

/* --- 大厂感细腻进场动画 --- */
.slide-in-1 {
    animation: scaleIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.slide-in-2 {
    animation: scaleIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.15s both;
}

.slide-in-3 {
    animation: scaleIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.3s both;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(10px);
    }

    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

/* 小屏手机高度弹性自适应 */
@media screen and (max-height: 670px) {
    .main-title-text {
        font-size: 28px;
    }
    .poetic-sentence {
        font-size: 15px;
        letter-spacing: 0.4px;
    }
    
}

/* PC等大屏端沙盒隔离 */
@media screen and (min-width: 1024px) {
    .report-container {
    width: 100% !important;
    height: 100vh !important;
    padding: 60px 10%; /* 侧边增加安全留白，防止内容贴边 */
    
    /* 单一背景图完美全屏铺满，不留任何死角 */
    background-image: url("../../assets/26June/pcbg.png") !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important; /* 核心：等比例拉伸，宁可裁剪也绝不留白 */
    
    /* 彻底移除手机端的圆角和边界阴影 */
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
  }

}
</style>